import React from "react"
import {Menu} from "@headlessui/react";
import {Link} from "react-router-dom";

interface IMenuDropProps {
    title: string,
    icon?: JSX.Element,
    isLinkBtn?: boolean,
    urlLinkProps?: Object,
    handleOnSubmit?: any
}

const MenuDropItem: React.FC<IMenuDropProps> = ({title, icon, handleOnSubmit = () => {}, isLinkBtn = false, urlLinkProps={}}) => {
    return (
        <div className="px-1 py-1">
            <Menu.Item>
                {({active}) => {
                    return isLinkBtn ?
                        <Link to={urlLinkProps}>
                            <div
                                className={`${active ? 'bg-primaryLight text-primary' : 'text-gray-900'} group flex w-full items-center rounded-md px-2 py-2 text-sm`}>
                                {icon && <span className={"mr-2 w-6 text-lg"}>{icon}</span>}
                                <span>{title}</span>
                            </div>
                        </Link>
                        :
                        <button
                            onClick={handleOnSubmit}
                            className={`${active ? 'bg-primaryLight text-primary' : 'text-gray-900'} group flex w-full items-center rounded-md px-2 py-2 text-sm`}>
                            {icon && <span className={"mr-2 w-6 text-lg"}>{icon}</span>}
                            <span>{title}</span>
                        </button>
                }}
            </Menu.Item>
        </div>
    )
}

export default MenuDropItem